import React from 'react'
import {
    Button,
    Icon,
    Menu,
    MenuButton,
    MenuList,
    Text,
} from '@chakra-ui/react'
import { FaChevronDown, FaCheckDouble, FaUser, FaXmark } from 'react-icons/fa6'

import MenuItem from '~components/shared/menu/menu-item'
import { useExportMessages } from '../export-messages-context'

export default function ExportSelectionMenu() {
    const {
        selectedMessages,
        selectAllMessages,
        selectManualMessages,
        clearSelectedMessages,
    } = useExportMessages()

    return (
        <Menu>
            <MenuButton
                as={Button}
                size="xs"
                height="28px"
                px={3}
                rounded="full"
                variant="subtle"
                bg="white"
                borderWidth={1}
                borderColor="gray.200"
                _hover={{ bg: 'gray.50' }}
                _active={{ bg: 'gray.100' }}
                rightIcon={<Icon as={FaChevronDown} fontSize="10px" />}
            >
                <Text fontSize="xs" color="gray.600" fontWeight="medium">
                    {selectedMessages.length} selected
                </Text>
            </MenuButton>
            <MenuList>
                <MenuItem icon={FaCheckDouble} onClick={selectAllMessages}>
                    Select all
                </MenuItem>
                <MenuItem icon={FaUser} onClick={selectManualMessages}>
                    Select only manual messages
                </MenuItem>
                <MenuItem
                    icon={FaXmark}
                    onClick={clearSelectedMessages}
                    isDisabled={selectedMessages.length === 0}
                >
                    Clear selection
                </MenuItem>
            </MenuList>
        </Menu>
    )
}
